import * as React from 'react';
import { Chip as MuiChip } from '@mui/material';
import { styled } from '@mui/system';

export interface ColorClass {
  primary: string;
  secondary: string;
}

type IProps = {
    color: ColorClass;
    icon: React.ReactElement;
};

export const Chip = styled(MuiChip)<{ colorClass: ColorClass }>(({ colorClass }) => ({
    backgroundColor: colorClass?.secondary,
    '& span': {
        display: 'none'
    },
    '& svg': {
        padding: '8px'
    },
    '& .MuiChip-icon': {
        margin: '0px',
        color: colorClass?.primary
    }
}));

const ChipComponent: React.FC<IProps> = (props: IProps) => {
    return <Chip size='small' icon={props.icon} colorClass={props.color} />;
};

export default ChipComponent;
